import { useMemo } from 'react';
import { IBotData } from '../models';

export const useBotValidation = (botData: IBotData) =>
  useMemo(() => {
    if (!botData.project_id) return false;
    if (!botData.weather_rating_id) return false;
    if (!botData.tag?.trim()) return false;

    if (botData.hasSupplyAir && !botData.sa_volume_max) return false;
    if (botData.hasReturnAir && !botData.ra_volume_max) return false;
    if (botData.hasExhaustAir && !botData.ea_volume_max) return false;

    if (
      !botData.construction_class_id ||
      !botData.voltage_id ||
      !botData.sa_ea_intake_configuration ||
      !botData.air_system_id ||
      !botData.tunnel_configuration
    ) {
      return false;
    }

    for (const tunnel of botData.tunnels) {
      if (!tunnel.sections.some((s) => s.type?.trim())) return false;

      for (const section of tunnel.sections) {
        if (section.type === 'fan' && !section.tsp) {
          return false;
        }
      }
    }

    return true;
  }, [botData]);
